import React, { Fragment } from 'react';
import RefreshIcon from '../icons/RefreshIcon';
import './analytics-grid-header.scss';
import AnalyticsFilterMenu from '../analytics-filter-menu/AnalyticsFilterMenu';
import { withAnalyticsAppContext } from '../../context/analytics-app-context';

function AnalyticsGridHeader({ appContext }) {
    const {
        loading,
        formattedTodayDate,
        loadAnalyticsAppData,
        filterAnalyticsDataByDate,
        filterAnalyticsDataByDateRange,
        displayLatestData,
        clearAnalyticsFilters,
        analyticsData,
        datesToFilter
    } = appContext;
    const {
        analyticsCardTitle,
        allAvailableDistinctDates
    } = analyticsData || {};

    function getAnalyticsFilterMenuText() {
        return loading ? 'Loading...' : analyticsCardTitle;
    }

    return (<Fragment>
        <div className='analytics-grid-header-title grid-item'>
            <h3>{'Welcome back'}</h3>
            <p>{formattedTodayDate}</p>
        </div>
        <div className='analytics-grid-header-actions grid-item'>
            <RefreshIcon onClick={loadAnalyticsAppData}></RefreshIcon>
            <AnalyticsFilterMenu
                onFilterByDateClick={filterAnalyticsDataByDate}
                onFilterByRangeClick={filterAnalyticsDataByDateRange}
                onDisplayLatestDataClick={displayLatestData}
                onClearFiltersClick={clearAnalyticsFilters}
                menuData={datesToFilter}
                buttonText={getAnalyticsFilterMenuText()}></AnalyticsFilterMenu>
        </div>
    </Fragment>
    );
}

export default withAnalyticsAppContext(AnalyticsGridHeader);
